import React from 'react'
import { DescriptionDiv } from './style'

function Description() {
    return (
        <DescriptionDiv>
            <div className=".inner-container">
                <div className="col-md-12">
                    <h2>Who we are.</h2>
                    <p className="m-5">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. <br/>
                        Soluta voluptatum consectetur dolore perferendis nam enim
                         nobis officiis rerum est, <br/> accusamus illum in amet tempora 
                         corrupti eligendi quas dicta. Dolorem, nesciunt.
                    </p>
                </div>
            </div>      
        </DescriptionDiv>
    )
}

export default Description
